import StarIcon from '@mui/icons-material/Star'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import getTestId from 'utils/getTestId'

import style from './FavoritesOnlyChip.module.css'

const FavoritesOnlyChip = ({ pressed, onClick }: { pressed: boolean; onClick: () => void }) => {
  const { t } = useTranslation()
  const label = t('favorites.only')
  return (
    <button
      type="button"
      className={clsx(style.btn, { [style.on]: pressed })}
      aria-pressed={pressed}
      aria-label={label}
      title={label}
      onClick={onClick}
      data-test-id={getTestId('favorites-only')}
    >
      <StarIcon className={style.icon} />
    </button>
  )
}

export default FavoritesOnlyChip
